import { forwardRef } from 'react';

import CanvasToolbar from '../CanvasToolbar';
import FabricCanvas from '../FabricCanvas';
import * as St from './DrawingArea.styles';

import { DrawingTabEnum } from '~/core/enums/drawing-tab.enum';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedDrawingTab } from '~/redux/slices/shape';
import { useDrawingShapeContext } from '~contexts';
import WaterfallPreviewer from '~molecules/WaterfallPreviewer';
import DrawingAreaDescriptor from '~organisms/DrawingAreaDescriptor';

type DrawingAreaProps = {
  canvasWidth: number;
};

const DrawingArea = forwardRef<HTMLDivElement, DrawingAreaProps>(
  ({ canvasWidth }: DrawingAreaProps, ref) => {
    const {
      getters: { areThereShapesInTheDrawingArea },
    } = useDrawingShapeContext();
    const selectedDrawingTab = useAppSelector(selectSelectedDrawingTab);

    const isFreeDrawingState =
      selectedDrawingTab === DrawingTabEnum.FREE_DRAWING_TAB;

    return (
      <St.Container ref={ref}>
        {!areThereShapesInTheDrawingArea && !isFreeDrawingState && (
          <DrawingAreaDescriptor />
        )}
        <St.CanvasWrapper style={{ maxWidth: canvasWidth }}>
          <FabricCanvas width={canvasWidth} />
          {areThereShapesInTheDrawingArea && <CanvasToolbar />}
          <St.CanvasWrapperPreviews>
            <WaterfallPreviewer />
          </St.CanvasWrapperPreviews>
        </St.CanvasWrapper>
      </St.Container>
    );
  }
);

DrawingArea.displayName = 'DrawingArea';

export default DrawingArea;
